// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-V4NU58","card":"card-BCAxXP","iconImg":"iconImg-iHRbgq","title":"title-gXiof_","body":"body-KwWCE8","cta":"cta-ujBx25"};